module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/onlinecalendars/bravenet_online_calendars_customizable.png";